import { render } from "./MusicBar.vue?vue&type=template&id=06c481f9&scoped=true"
import script from "./MusicBar.vue?vue&type=script&lang=js"
export * from "./MusicBar.vue?vue&type=script&lang=js"

import "./MusicBar.vue?vue&type=style&index=0&id=06c481f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c481f9"]])

export default __exports__